
document.addEventListener("DOMContentLoaded", function () {
  const viewMoreBtn = document.querySelector("#viewMoreBtn");
  const hiddenItems = document.querySelectorAll(".hidden-item") || [];

  if (!viewMoreBtn) return;

  viewMoreBtn.setAttribute("aria-expanded", "false");
  viewMoreBtn.setAttribute("role", "button");
  viewMoreBtn.setAttribute("tabindex", "0");

  let isExpanded = false;

  const toggleVisibility = function (e, triggeredByClick = true) {
    e.preventDefault();
    isExpanded = !isExpanded;

    viewMoreBtn.setAttribute("aria-expanded", isExpanded.toString());

    hiddenItems.forEach((item) => {
      item.classList.toggle("hidden-item", !isExpanded);
    });

  
    viewMoreBtn.innerHTML = viewMoreBtn.innerHTML.replace(
      isExpanded ? "View More" : "View Less",
      isExpanded ? "View Less" : "View More"
    );

    
    if (!isExpanded && triggeredByClick) {
      const sectionWrapper = viewMoreBtn.closest(".highlights"); 
      if (sectionWrapper) {
        const headingElement = sectionWrapper.querySelector(".highlights__title"); 
        if (headingElement) {
          headingElement.scrollIntoView({ behavior: "smooth", block: "start" }); 
        }
      }
    }
  };


  viewMoreBtn.addEventListener("click", function (e) {
    toggleVisibility(e, true);
  });
  
  viewMoreBtn.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleVisibility(e, false); 
    }
  });
});